// src/utils/axiosConfig.js
import axios from "axios";
import { getValidRefreshedToken, getAuthToken } from "@/utils/authUtils";

// Create axios instance with base URL
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_DEV_API_URL, // Use an environment variable for base URL
  headers: {
    "Content-Type": "application/json",
  },
});

// Example: Add an interceptor to attach authorization token to requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    // Access token expired: refresh once, then retry the original request.
    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      const newToken = await getValidRefreshedToken();
      if (newToken) {
        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      }
      // Refresh token missing/expired -> log out.
      localStorage.removeItem("loginDetails");
      localStorage.removeItem("isAuthenticated");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
